export default {
     'team': 'team',
     'hero': 'hero',
     'support': 'support',
     'pet': 'pet',
     'menu': 'menu'
}